import { FC, useEffect } from 'react';
import { usePlyLoader } from '../meshLoadingHooks';
import { MetricKeyEnum, useLayerStore } from '../LayerControls/layerStore';

interface BentDeviationMeshProps {
  bentDeviationMeshUrl: string;
  accessToken: string;
}

const bentDeviationMeshLayerKey = MetricKeyEnum.BentDeviation;

export const BentDeviationMesh: FC<BentDeviationMeshProps> = ({
  bentDeviationMeshUrl,
  accessToken,
}) => {
  const bentDeviationMesh = usePlyLoader(bentDeviationMeshUrl, accessToken);

  const { addLayerState, isLayerVisible } = useLayerStore();

  useEffect(() => {
    addLayerState(bentDeviationMeshLayerKey, {
      key: bentDeviationMeshLayerKey,
      visible: true,
    });
  }, [addLayerState]);

  const showLayer = isLayerVisible(bentDeviationMeshLayerKey);

  return (
    <group visible={showLayer}>
      <mesh geometry={bentDeviationMesh} castShadow>
        <meshPhongMaterial
          color={0xffffff}
          flatShading={true}
          vertexColors={true}
          shininess={0}
          toneMapped={false}
        />
      </mesh>
    </group>
  );
};
